// extracted by mini-css-extract-plugin
export default {"modal":"side-modal_modal__ARLbu"};